import _getCookies from './getCookies';
async function getCookies(name) {
    return _getCookies(name);
}
export default getCookies;
